const PT_DATA = {
  menu: [
    "HOME",
    "SERVIÇOS",
    "SOBRE NÓS",
    "GALERIA",
    "CONTATO",
    "LOGIN",
    "LOGOUT",
    "ÁREA DO ALUNO",
  ],
  sections: {
    message: [
      "Aviso importante!",
      "Estamos funcionando regularmente e de acordo com todas as diretrizes do governo. Por ser considerado educação e um treinamento profissionalizante que só pode ser entregue presencialmente, nosso curso de barista tem permissão para continuar com as aulas presenciais.",
    ],
    services: ["SERVIÇOS", "Cursos Online", "Cursos Presenciais", "Veja mais"],
    about: [
      "SOBRE NÓS",
      "A Head Start Courses é uma empresa com sede em Dublin formada por Bartira Augelli, profissional renomada e focada na área de treinamentos na Irlanda, incluindo cursos de Food Safety (HACCP - Level 1) e Barista, além de oferecer suporte para o desenvolvimento de currículo dos estudantes. Ambos são oferecidos no ambiente presencial ou online, em inglês ou português, contribuindo especialmente àqueles que precisam de um conteúdo eficaz e claro para conseguirem um emprego na Irlanda.",
      "Com uma linguagem simples, dinâmica e envolvente, a Head Start Courses auxilia através do treinamento adequado, com o objetivo de desenvolver a confiança necessária para que o estudante se destaque no mercado de trabalho, contribuindo, assim, com sua jornada pessoal e profissional.",
      "MISSÃO",
      "Entregar conhecimento de forma leve e eficaz, desenvolvendo pessoal e profissionalmente o aluno.",
      "VISÃO",
      "Ser referência na formação de profissionais destaques no setor alimentício da Irlanda, contribuindo com a vida dos imigrantes e com o país.",
      "VALORES",
      "Honestidade, Integridade, Respeito e Inclusão",
      "SOBRE A PROFISSIONAL",
      "“Meu negócio surgiu quando percebi que meu conhecimento e experiência poderiam gerar um  impacto positivo na vida das pessoas, principalmente intercambistas como eu. Desde então, minha alegria é trabalhar com o que amo e saber que contribuo para o start de muitos profissionais.”",
      "(BARTIRA)",
      'Com mais de uma década de experiência no setor alimentício irlandês, sou Bartira Augelli, fundadora da Head Start Courses e do renomado Barista Course By Bartira. Minha formação acadêmica inclui um Mestrado em Ciências em Empreendedorismo pela Trinity College Dublin, um Mestrado em Jornalismo e Comunicação  pela Griffith College Dublin e um Bacharelado em Administração (com honras) pela International College Dublin. Também possuo uma certificação de nível 6 em "Design e Validação HACCP Avançado com base em Avaliação de Riscos".',
      "Minha paixão por ensinar é fundamental para minha vida profissional, o que me levou a buscar uma certificação em Mentoria pela Trinity College Dublin. Além disso, sou Barista certificada pela Specialty Coffee Association of Europe (SCAE).",
      `Nos últimos dez anos, meu curso de barista qualificou com sucesso mais de 7.000 profissionais. Antes da pandemia, eu também administrava uma cafeteria estilosa localizada na British Studies Center em Dublin 1. Após a pandemia, abri um espaço menor para aulas também em Dublin 1, com foco em aulas de barista. Depois de três anos, `,
      `mudei-me para uma unidade comercial maior e com uma decoração incrível no coração de Stoneybatter.`,
      `Sempre foi meu sonho abrir um negócio lá, pois minhas aulas de barista combinam perfeitamente com a atmosfera vibrante e inclusiva da região. Além do meu negócio principal, dedico meu tempo a palestras, workshops de treinamento, escrevo para o Dublin Inquirer e participo de programas sociais. Ocasionalmente, ensino técnicas de barista para jovens "difíceis de alcançar" de origens marginalizadas em Dublin.`,
      "Aperte o play e comece hoje sua jornada profissional!",
    ],
    contact: [
      "CONTATO",
      "Preencha o formulário abaixo. Retornaremos assim que possível.",
      "Nome",
      "Email",
      "Telefone",
      "Assunto",
      "Dúvidas",
      "Assistência Técnica",
      "Comentários",
      "Outros",
      "Mensagem",
      "Enviar",
      "Localização",
      "Você pode encontrar a Head Start Courses em:",
      "Seja muito bem-vindo! É um prazer ter você conosco!",
      "* Estacionamento gratuito disponível mediante solicitação",
    ],
    login: ["Email", "Senha", "Criar nova conta", "Esqueceu a Senha?"],
    security: ["Politica de Segurança"],
    cart: [
      "Carrinho",
      "Cursos no Carrinho",
      "CONFIRMAR",
      "Inserir Voucher",
      "APLICADO",
      "APLICAR",
      "O carrinho está vazio. Encontre um curso para você!",
      "ir às compras",
    ],
    coursecart: [
      "Veja mais",
      "Vejas as datas disponíveis aqui!",
      "Adicionar",
      "Datas disponíveis",
      "Horário:",
      "Clique para comprar!",
      "Apenas",
      "vaga(s)",
      "Sem vagas disponíveis!",
      "Sem vagas disponíveis!",
      "Ainda estamos carregando os dados desta aula. Tente novamente em instantes.",
      "Já reservado",
    ],
    dashboard: [
      "Oi",
      "EDITAR",
      "Estudante",
      "LIMITE:",
      "DATA CURSO:",
      "Finalizado",
      "Expirado",
      "Abrir",
      "Comprado",
      "Agendar",
    ],
    editUser: [
      "Editar Usuário",
      "Nome",
      "Endereço",
      "Celular",
      "ATUALIZAR",
      "CANCELAR",
    ],
    createUser: ["Cadastro realizado com sucesso!", "Fazer Login"],
    congratulations: [
      "Parabéns! Você finalizou o curso Food Safety - HACCP(Level 1).",
      "O certificado foi enviado para o seu email!",
      "Voltar para Área do Aluno",
    ],
    gallery: [
      "NOSSA GALERIA",
      "Nenhuma imagem para ser carregada",
      "Nosso Espaço",
      "Nossas Aulas",
      "Nossa História",
    ],
  },
}

export default PT_DATA
